import * as React from "react";

import {RouteComponentProps, withRouter} from "react-router";
import {LoadingViewState, RouterView} from "../RouterView";
import {BonusConfig, BonusOffer, BonusOfferStatus, CurrencyDefinition, Settings} from "../../http/protocol";
import {Form, FormListener} from "../form/Form";
import {getContainer} from "../../ioc/IOCSetup";
import {FormGroup} from "../form/FormGroup";
import {FormInput} from "../form/FormInput";
import {FormSubmitError, FormSubmitSuccess} from "../form/FormFeedback";
import {Submit} from "../form/Submit";
import {Validators} from "../form/Validators";
import {SettingsService} from "../../services/SettingsService";
import {BonusConfigService} from "../../services/BonusConfigService";
import {SelectInput} from "../form/SelectInput";
import 'react-day-picker/lib/style.css'
import {BonusOfferService} from "../../services/BonusOfferService";
import {FormUtils} from "../form/FormUtils";
import "react-datetime/css/react-datetime.css";
import {FormDateTimeInput} from "../form/FormDateTimeInput";

interface State extends LoadingViewState {
    tc? : BonusOffer;
    validationMap? : any;
    currencies? : CurrencyDefinition[];
    bonusConfigs? : BonusConfig[];
}

export class EditBonusOffer extends RouterView<RouteComponentProps,State> implements FormListener<BonusOffer>{

    service : BonusOfferService;
    settingsService : SettingsService;
    bonusConfigService : BonusConfigService;

    constructor(props : RouteComponentProps){
        super(props);
        this.service = getContainer().getBonusOfferService();
        this.settingsService = getContainer().getSettingsService();
        this.bonusConfigService = getContainer().getBonusConfigService();
        const month:Date = new Date(new Date().setDate(new Date().getDate()+30));

        this.state = { tc : {expires:month }, validationMap : {}, bonusConfigs : [] };
    }

    getTitle(): string {
        return "Edit Bonus Offer";
    }

    componentDidUpdate(prevProps : RouteComponentProps, prevState : State) {
        if((prevProps.match.params as any).id !== (this.props.match.params as any).id)  {
            this.refreshContent();
        }
    }

    loadContent(): Promise<any>  {


        if((this.props.match.params as any).id !== "new") {
            return Promise.all([
                this.bonusConfigService.list({ offset : 0, limit: 100, orderBy : "name"}),
                this.settingsService.getSettings()
            ]).then( (res : any[])=>{
                let currencies = (res[1] as Settings).currencies;
                this.setState({ bonusConfigs : res[0].items, currencies : currencies })
                return this.service.getEntity((this.props.match.params as any).id).then((tc : BonusOffer) => {
                    this.setState({ tc : tc });

                });
            });

        }
        return this.settingsService.getSettings().then( (s : Settings) => {
            this.setState({  currencies : s.currencies});
        }).then(()=>{
            return Promise.all([
                this.bonusConfigService.list({ offset : 0, limit: 100, orderBy : "name"}),
            ]).then( (res : any[])=>{
               this.setState({ bonusConfigs : res[0].items});
            });
        })

    }

    onSubmit()  {
        if(!this.state.tc) return;
        return this.service.save(this.state.tc).then((s : BonusOffer)=> {
            this.setState({tc : s});
        })
    }

    formDidUpdate(formModel: BonusOffer, validationMap?: any) {
        this.setState({tc : formModel, validationMap : validationMap})
    }
    getCurrencyLabel(code : string) {
        if(this.state.currencies) {
            let c = this.state.currencies.find( c => c.code === code);
            if(c) {
                return c.name + " (" + c.code + ")";
            }
        }
        return "";
    }
    findBonusById( id : number) : BonusConfig {
        if(!this.state.bonusConfigs) {
            return {}
        }
        let res =  this.state.bonusConfigs.find((b : BonusConfig) => b.id+"" === id+"")
        if(!res) {
            return {};
        }
        return res;
    }

    renderContent() {
        if(!this.state.tc || !this.state.currencies) {
            return <span></span>
        }

        return (
            <div>


                <div className="wrapper wrapper-content animated fadeInRight">
                    <Form className="form form-horizontal" validationMap={this.state.validationMap} modelObject={this.state.tc} formListener={this}>
                        <div className="row">
                            <div className="col-lg-12">

                                <div className="card-box">
                                    <div className="ibox-content">
                                        {(this.props.match.params as any).id !== "new" && (   <div className="hr-line-dashed"></div> )}

                                        {(this.props.match.params as any).id !== "new" && (
                                            <FormGroup className="form-group">
                                                <label className="col-sm-2 control-label">ID</label>
                                                <div className="col-sm-10">
                                                    <FormInput  model="id" type="integer"  className="form-control" disabled={true}/>
                                                </div>
                                            </FormGroup>
                                        )}


                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">User Id</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="userId" validators={[Validators.required()]} type="text"  className="form-control" />
                                                <span className={"help"}>The ID of the user to give the bonus offer to.</span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Expires</label>
                                            <div className="col-sm-10">
                                                <FormDateTimeInput model={"expires"}/>
                                                <span className={"help"}>When this offer will expire</span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Payment</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="paymentId"  type="number"  className="form-control" />
                                                <span className={"help"}>This is the id of the payment linked to the offer</span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Amount</label>
                                            <div className="col-sm-10">
                                                <FormInput  model="amount"  type={"float"} className="form-control" validators={[Validators.required(), Validators.number()]} />
                                                <span className={"help"}>The amount of this offer</span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>
                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Currency</label>
                                            <div className="col-sm-10">
                                                <SelectInput  model="currency" values={this.state.currencies.map(c => c.code)} className="form-control" />
                                                <span className={"help"}>Currency of this offer</span>
                                            </div>
                                        </FormGroup>

                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Status</label>
                                            <div className="col-sm-10">
                                                <SelectInput values={Object.keys(BonusOfferStatus)}  displayValue={FormUtils.fromEnum} model="status"  className="form-control" />
                                                <span className={"help"}>The status of this offer</span>
                                            </div>
                                        </FormGroup>
                                        <div className="hr-line-dashed"></div>

                                        <FormGroup className="form-group">
                                            <label className="col-sm-2 control-label">Bonus Config</label>
                                            <div className="col-sm-10">
                                                <SelectInput  model="bonusConfig" values={this.state.bonusConfigs}
                                                              optionModelValue={(m : BonusConfig) => m.id}
                                                              convertOptionValueToModel={(id : number) => this.findBonusById(id) }
                                                              convertModelValueToOption={(b : BonusConfig) => b.id}
                                                              displayValue={(b : BonusConfig) => b.name + " ("+b.id+")"}  className="form-control" />

                                                <span className={"help"}>The bonus config that this offer applies for</span>
                                            </div>
                                        </FormGroup>
                                    </div>
                                </div>

                            </div>
                        </div>


                        <div className="row">
                            <div className="col-lg-12">
                                <div className="card-box">

                                    <FormSubmitError />
                                    <FormSubmitSuccess text="Account was updated successfully"/>
                                    <div className="form-group">
                                        <div className="col-sm-12">
                                            <Submit className="btn  btn-primary">Save</Submit>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </Form>
                </div>
            </div>
        );
    }

}


export default withRouter(EditBonusOffer);